// Export hooks here
export { default as useEncryptService } from '../../utils/rsaEncryption';

export const useAuth = () => {
  // Mock auth hook for now
  return {
    logout: async () => {
      console.log('Logout called');
    },
  };
};

export const useStorageManager = () => {
  return {
    getFromLocalStorage: (key: string) => {
      return localStorage.getItem(key);
    },
    setToLocalStorage: (key: string, value: string) => {
      localStorage.setItem(key, value);
    },
  };
};

export const useTokens = () => {
  return {
    clearTokens: () => {
      localStorage.clear();
    },
  };
}; 